import {
  ADD_FAVOURITE_MEMBER,
  ADD_FAVOURITE_MEMBER_SUCCESS,
  FETCH_MEMBER,
  FETCH_MEMBER_SUCCESS,
  FETCH_ALL_MEMBER,
  FETCH_ALL_MEMBER_SUCCESS,
  FILTER_MEMBER,
  GET_ALL_MEMBER,
  GET_UNSELECTED_ALL_MEMBER,
  HANDLE_MEMBER_REQUEST_CLOSE,
  HIDE_MEMBER_LOADER,
  SHOW_MEMBER_LOADER,
  ON_ADD_MEMBER,
  ON_EDIT_MEMBER,
  ON_ALL_MEMBER_SELECT,
  ON_MEMBER_CLOSE,
  ON_MEMBER_SELECT,
  ON_DELETE_MEMBER,
  ON_DELETE_MEMBER_SUCCESS,
  ON_FILTER_SELECTED_MEMBER,
  ON_FILTER_MEMBER_OPTION_SELECT,
  ON_SAVE_MEMBER,
  ON_SAVE_MEMBER_SUCCESS,
  ON_TOGGLE_MEMBER_DRAWER,
  SHOW_MEMBER_MESSAGE,
  UPDATE_SEARCH_MEMBER,
} from 'constants/ActionTypes';

export const fetchMember = (payload) => {
  return {
      type: FETCH_MEMBER,
      payload
  };
};
export const fetchMemberSuccess = (payload) => {
  return {
      type: FETCH_MEMBER_SUCCESS,
      payload
  };
};
export const fetchMembers = () => {
  return {
      type: FETCH_ALL_MEMBER
  };
};
export const fetchMembersSuccess = (payload) => {
  return {
      type: FETCH_ALL_MEMBER_SUCCESS,
      payload
  };
};
export const showMemberMessage = (message) => {
  return {
      type: SHOW_MEMBER_MESSAGE,
      payload: message
  };
};
export const addFavouriteMember = (payload) => {
  return {
      type: ADD_FAVOURITE_MEMBER,
      payload
  };
};
export const addFavouriteMemberSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_MEMBER_SUCCESS,
      payload
  };
};
export const onMemberSelect = (payload) => {
  return {
      type: ON_MEMBER_SELECT,
      payload
  };
};
export const onAddMember = () => {
  return {
      type: ON_ADD_MEMBER,
  };
};
export const onEditMember = (payload) => {
  return {
      type: ON_EDIT_MEMBER,
      payload
  };
};
export const onMemberClose = () => {
  return {
      type: ON_MEMBER_CLOSE,
  };
};
export const onFilterMemberOptionSelect = (payload) => {
  return {
      type: ON_FILTER_MEMBER_OPTION_SELECT,
      payload
  };
};
export const onSaveMember = (payload) => {
  return {
      type: ON_SAVE_MEMBER,
      payload
  };
};
export const onSaveMemberSuccess = (data) => {
  return {
      type: ON_SAVE_MEMBER_SUCCESS,
      payload: data
  };
};
export const onDeleteMember = (payload) => {
  return {
      type: ON_DELETE_MEMBER,
      payload
  };
};
export const onDeleteMemberSuccess = (payload) => {
  return {
      type: ON_DELETE_MEMBER_SUCCESS,
      payload
  };
};
export const onFilterSelectedMember = () => {
  return {
      type: ON_FILTER_SELECTED_MEMBER,
      payload: ''
  };
};
export const filterMember = (payload) => {
  return {
      type: FILTER_MEMBER,
      payload
  };
};
export const getAllMember = () => {
  return {
      type: GET_ALL_MEMBER,
      payload: ''
  };
};
export const getUnselectedAllMember = () => {
  return {
      type: GET_UNSELECTED_ALL_MEMBER,
      payload: ''
  };
};
export const onAllMemberSelect = () => {
  return {
      type: ON_ALL_MEMBER_SELECT,
      payload: ''
  };
};
export const updateSearchMember = (payload) => {
  return {
      type: UPDATE_SEARCH_MEMBER,
      payload
  };
};
export const onToggleMemberDrawer = () => {
  return {
      type: ON_TOGGLE_MEMBER_DRAWER,
  };
};
export const handleMemberRequestClose = () => {
  return {
      type: HANDLE_MEMBER_REQUEST_CLOSE,
  };
};
export const showMemberLoader = () => {
  return {
      type: SHOW_MEMBER_LOADER,
  };
};
export const hideMemberLoader = () => {
  return {
      type: HIDE_MEMBER_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/member.js